module.exports = __webpack_public_path__ + "static/media/roche.0c8d1200.png";